export default "__VITE_ASSET__66320222__"